/**
 * HowItWorksSection — numbered step list (dark variant) explaining the
 * flow from sign-up to publishing. Step content comes from i18n.
 */

import { useTranslation } from 'react-i18next';

import {
  Section,
  Container,
  SectionHeader,
  SectionEyebrow,
  SectionTitle,
  StepsGrid,
  StepItem,
  StepNumber,
  StepConnector,
  StepTitle,
  StepBody,
} from '../../common/LandingPage.styled';

interface Step {
  n: string;
  title: string;
  body: string;
}

export function HowItWorksSection() {
  const { t } = useTranslation();
  const steps = t('landing.howItWorks.steps', { returnObjects: true }) as Step[];

  return (
    <Section dark id="how-it-works">
      <Container>
        <SectionHeader>
          <SectionEyebrow>{t('landing.howItWorks.eyebrow')}</SectionEyebrow>
          <SectionTitle>{t('landing.howItWorks.title')}</SectionTitle>
        </SectionHeader>
        <StepsGrid>
          {steps.map(({ n, title, body }) => (
            <StepItem key={n}>
              <StepNumber>{n}</StepNumber>
              <StepConnector />
              <StepTitle>{title}</StepTitle>
              <StepBody>{body}</StepBody>
            </StepItem>
          ))}
        </StepsGrid>
      </Container>
    </Section>
  );
}

export default HowItWorksSection;
